/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_A2Inputs */

const en_guide_json_syntax_errors_faq_a2 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can use <code>JSON.parse()</code> in any browser's developer console. If it throws a SyntaxError, the JSON is invalid. The error message will often indicate the position of the problem.`)
};

const ko_guide_json_syntax_errors_faq_a2 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저의 개발자 콘솔에서 <code>JSON.parse()</code>를 사용할 수 있습니다. SyntaxError가 발생하면 JSON이 유효하지 않은 것입니다. 오류 메시지가 보통 문제의 위치를 알려줍니다.`)
};

const ja_guide_json_syntax_errors_faq_a2 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザの開発者コンソールで<code>JSON.parse()</code>を使用できます。SyntaxErrorがスローされれば、そのJSONは無効です。エラーメッセージには問題の位置が示されることが多いです。`)
};

/**
* | output |
* | --- |
* | "You can use <code>JSON.parse()</code> in any browser's developer console. If it throws a SyntaxError, the JSON is invalid. The error message will often indic..." |
*
* @param {Guide_Json_Syntax_Errors_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_a2 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_a2(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_a2(inputs)
	return ja_guide_json_syntax_errors_faq_a2(inputs)
});